import { render } from "./UserData.vue?vue&type=template&id=a3ab0418&scoped=true"
import script from "./UserData.vue?vue&type=script&lang=js"
export * from "./UserData.vue?vue&type=script&lang=js"

import "./UserData.vue?vue&type=style&index=0&id=a3ab0418&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ab0418"]])

export default __exports__